import React, {useState} from 'react';
import { connect } from "react-redux";
import {isPc} from '../../utils/util';

import Modal from '../Modal';

function Rules ({probabilityList}) {
    const [isProbabilityVisible, setIsProbabilityVisible] = useState(false);
    const len = probabilityList.length;
    // const showModal = () => {
    //     setIsProbabilityVisible(true);
    // }

    const hideModal = () => {
        setIsProbabilityVisible(false)
    }
    return (
        <div className="m-rules">
            <div className="m-rule-hd"></div>
            <ul>
                <li><p>活动时间与活动对象：即日起至6月30日，VIP邮箱15元及以上套餐帐号可参与，其他餐用户可升级参与（升级后不支持降级）；本活动不与积分活动同享；</p></li>
                <li><p>活动期间，用户<span style={{color: 'red'}}>在本活动页支付</span>网易VIP邮箱每满6个月，得1次翻牌机会，且每个帐号最多只有2次翻牌机会；</p></li>
                <li><p>用户每次翻牌必得其中1个奖品，且同一帐号2次翻牌获得的奖品不重复；抽奖次数有效期为活动结束后7天内，过期失效；</p></li>
                <li>
                    <p>本次活动奖品包括华为Mate30 Pro 5G（翡冷翠 8G+512G）手机、6个月VIP邮箱服务期、1年VIP邮箱服务期、8元VIP邮箱服务期及199元网易理财课程；</p>
                    <p>其中服务期类奖品会自动发放到用户帐户，获得该奖品的用户，可进入邮箱“个人中心”-“个人帐户”-“续费记录”查看赠送情况；获得199元理财课程的用户，请在7天内，根据提示扫码添加班主任微信领取；</p>
                    <p>获得华为手机的用户，请在“我的礼品”填写收货地址，提交的地址信息若有问题可联系邮箱管家修改，礼品将于活动结束后15个工作日内寄出；</p>
                </li>
                <li><p>在参与活动的过程中，如用户出现或涉嫌违法违规行为，网易有权取消用户活动参与资格，并有权收回用户已经获得的礼品奖励；</p></li>
                <li><p>以上，如有任何疑问，可联系邮箱管家，管家专线：4009-163-163</p></li>
            </ul>

            {
                isPc() ? <Modal isOpen={isProbabilityVisible} title="奖品综合中奖概率" className="w-probability-modal" onClose={hideModal}>
                    <div className="w-probability-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>奖品</th>
                                    {
                                        probabilityList.map((item, index) => {
                                            return (<th key={index} className={(len-1) === index ? 'lastCol' : ''}>{item.name}</th>)
                                        })
                                    }
                                </tr>
                            </thead>
                            <tbody>
                                <tr className="lastrow">
                                    <th>综合概率</th>
                                    {
                                        probabilityList.map((item, index) => {
                                            return (<td key={index} className={(len-1) === index ? 'lastCol' : ''}>{item.probability}</td>)
                                        })
                                    }
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </Modal>
                :
                <Modal isOpen={isProbabilityVisible} title="奖品综合中奖概率" className="w-probability-modal" onClose={hideModal}>
                    <div className="w-probability-table">
                        <table>
                            <thead>
                                <tr>
                                    <th>奖品</th>
                                    <th className="lastCol">综合概率</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    probabilityList.map((item, index) => {
                                        return (
                                            <tr className={(len-1) === index ? 'lastrow' : ''} key={index}>
                                                <td>{item.name}</td>
                                                <td className="lastCol">{item.probability}</td>
                                            </tr>
                                        )
                                    })
                                }
                            </tbody>
                        </table>
                    </div>
                </Modal>
            }
        </div>
    )
}

function mapStateToProps(state) {
    return {
        probabilityList: state.global.probabilityList || []
    }
  }
  
  function mapDispatchToProps(dispatch) {
    return {
      
    }
  }
  
export default connect(mapStateToProps, mapDispatchToProps)(Rules);
